/* AE: pane mega menu switching (snippets/ae-mega-panes.liquid, ae-imm.css section 32).
   Hovering (after a short pause, so a diagonal move across the rail doesn't flip it), focusing
   or clicking a rail item shows its year ranges or links; a year range shows its categories.
   Delegated from document, so it survives Horizon re-rendering the header. */
(() => {
  const HOVER_DELAY = 90;
  let timer = null;

  const setActive = (items, predicate) => {
    items.forEach((el) => el.classList.toggle('is-active', predicate(el)));
  };

  const showPanel = (root, key) => {
    setActive(root.querySelectorAll('.ae-mp__panel'), (el) => el.dataset.aeMpPane === key);
  };

  const show = (item) => {
    const root = item.closest('[data-ae-mp]');
    if (!root || item.classList.contains('is-active')) return;
    const key = item.dataset.aeMpKey;
    const level = item.dataset.aeMpLevel;

    setActive(root.querySelectorAll(`[data-ae-mp-level="${level}"]`), (el) => el === item);

    if (level === 'rail' && root.classList.contains('ae-mp--vehicle')) {
      let list = null;
      setActive(root.querySelectorAll('.ae-mp__list'), (el) => {
        const on = el.dataset.aeMpPane === key;
        if (on) list = el;
        return on;
      });
      const first = list && list.querySelector('[data-ae-mp-level="year"]');
      if (first) {
        first.classList.remove('is-active');
        show(first);
      }
    } else {
      showPanel(root, key);
    }
  };

  const target = (event) => event.target.closest && event.target.closest('[data-ae-mp-level]');

  document.addEventListener('pointerover', (event) => {
    if (event.pointerType === 'touch') return;
    const item = target(event);
    clearTimeout(timer);
    if (item) timer = setTimeout(() => show(item), HOVER_DELAY);
  });

  document.addEventListener('focusin', (event) => {
    const item = target(event);
    if (item) show(item);
  });

  document.addEventListener('click', (event) => {
    const item = target(event);
    if (item && item.tagName === 'BUTTON') show(item);
  });
})();
